import { Hide, Menu, MenuButton, IconButton, MenuList, Show, VStack } from '@chakra-ui/react';
import { FiFilter } from 'react-icons/fi';
import { ClearFiltersButton } from './ClearFiltersButton';

export const FilterBox = (props: {
  isDisabled?: boolean,
  children: React.ReactNode,
  onClearAllFilters?: () => void,
  hasActiveFilters?: boolean
}) => {
  return <>
    <Hide above='lg'>
      <Menu isLazy>
        <MenuButton as={IconButton} isDisabled={props.isDisabled} variant='ghost' icon={<FiFilter />} />
        <MenuList pl='4' lineHeight='1.5'>
          <VStack align="stretch" spacing="2">
            {props.children}
            <ClearFiltersButton
              onClearAllFilters={props.onClearAllFilters}
              hasActiveFilters={props.hasActiveFilters}
              isDisabled={props.isDisabled}
            />
          </VStack>
        </MenuList>
      </Menu>
    </Hide>
    <Show above='lg'>
      {props.children}
      <ClearFiltersButton
        onClearAllFilters={props.onClearAllFilters}
        hasActiveFilters={props.hasActiveFilters}
        isDisabled={props.isDisabled}
        width="fit-content"
      />
    </Show>
  </>;
};